export const EventTypes = {
  // User Interactions
  CLICK: 'CLICK',
  SUBMIT: 'CLICK',
  VIEW: 'PAGE_VIEW',
  LOGIN: 'LOGIN',

  // Download Events
  DOWNLOAD: 'DOWNLOAD',
  ASSET_CARD_DOWNLOAD: 'ASSET_CARD_DOWNLOAD',
  UNINITIATED_DOWNLOAD: 'UNINITIATED_DOWNLOAD',

  // Search Events
  SEARCH_PAGE_CHANGE: 'SEARCH_PAGE_CHANGE',
  SEARCH_PAGE_SORT_CHANGE: 'SEARCH_PAGE_SORT_CHANGE',
  SEARCH_PAGE_RESULTS_CHANGE: 'SEARCH_PAGE_RESULTS_CHANGE',
  SEARCH_HIGHLIGHTS: 'SEARCH_HIGHLIGHTS',

  // Project Events
  PROJECT_CREATE: 'PROJECT_CREATE',
  PROJECT_LIST_SORT: 'PROJECT_LIST_SORT',
  PROJECT_LIST_FILTER: 'PROJECT_LIST_FILTER',
  PROJECT_LIST_PAGE: 'PROJECT_LIST_PAGE',

  // Board Events
  BOARD_CREATE: 'BOARD_CREATE',
  BOARD_UPDATE: 'BOARD_UPDATE',
  BOARD_DELETE: 'BOARD_DELETE',
  BOARD_ADD_ASSET: 'BOARD_ADD_ASSET',
  BOARD_REMOVE_ASSET: 'BOARD_REMOVE_ASSET',

  // Metadata Events
  UPDATE_ASSET_METADATA: 'UPDATE_ASSET_METADATA',
  BULK_UPDATE_ASSET_METADATA: 'BULK_UPDATE_ASSET_METADATA',

  // Template Events
  LIBRARIAN_TEMPLATE_CHANGE: 'LIBRARIAN_TEMPLATE_CHANGE',

  // Publish Events
  PUBLISH_ASSET_COPY: 'PUBLISH_ASSET_COPY',
  PUBLISH_SEARCH: 'PUBLISH_SEARCH',
  PUBLISH_UPLOAD_FILES_DOWNLOAD: 'PUBLISH_UPLOAD_FILES_DOWNLOAD',

  // Upload Events
  UPLOAD: 'UPLOAD',

  // Error Events
  API_ERROR: 'API_ERROR',
}

/**
 * Event Categories for grouping related events
 */
export const EventCategories = {
  USER_INTERACTION: 'USER_INTERACTION',
  DOWNLOAD: 'DOWNLOAD',
  SEARCH: 'SEARCH',
  PROJECT: 'PROJECT',
  BOARD: 'BOARD',
  METADATA: 'METADATA',
  TEMPLATE: 'TEMPLATE',
  PUBLISH: 'PUBLISH',
  UPLOAD: 'UPLOAD',
  ERROR: 'ERROR',
}

/**
 * Event Priority Levels
 */
export const EventPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
}
